<template>
  <div class="alert alert-subtle-warning admin-extra-info py-2 mb-0">
    <div class="form-check mb-0">
      <input
        :id="checkboxId"
        v-model="shown"
        class="form-check-input"
        type="checkbox"
        :disabled="disabled || locked"
        data-testid="advanced-listing"
      />
      <label class="form-check-label" :for="checkboxId"
        >{{ $t("forwards.mandates.advanced_listing.label") }}
        <InfoTooltip :text="$t('forwards.mandates.advanced_listing.hint')"
      /></label>
    </div>
    <p
      v-if="locked"
      class="text-body-tertiary fs-10 mb-0 mt-1"
      data-testid="advanced-listing-locked"
    >
      {{ $t("forwards.mandates.advanced_listing.locked") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import InfoTooltip from "@/components/common/InfoTooltip.vue";
import { computed, useId } from "vue";

/**
 * Staff's per-mandate choice between the simple listing editor (a recurring listing's quarters) and
 * every listing shape. Producers never see the box, only the editor staff chose for them.
 *
 * While the listing has a shape only the advanced editor can show, the box reads ticked and cannot
 * be cleared: unticking would hide what the mandate lists. It frees up once the listing is back to a
 * simple one, and is never cleared on its own.
 */
const props = withDefaults(
  defineProps<{
    /** The form's listing fits the simple editor (`mandateListingView.hasSimpleShape`). */
    simpleShape: boolean;
    disabled?: boolean;
  }>(),
  { disabled: false }
);

const advanced = defineModel<boolean>({ required: true });

const checkboxId = useId();

const locked = computed(() => !props.simpleShape);

const shown = computed({
  get: () => advanced.value || locked.value,
  set: (value: boolean) => {
    advanced.value = value;
  },
});
</script>
